module.exports = __webpack_public_path__ + "assets/icon-close.013ecccb.svg";